import { __awaiter } from "tslib";
import { enums } from '@optimizely/optimizely-sdk';
import getOptimizelyVanillaSDKInstance from '../../common/getOptimizelyVanillaSDKInstance';
import consoleEvents from '../../consoleEvents';
import optimizelyVanillaOnDecision from '../optimizelyVanillaOnDecision';
/**
 * Return optimizely vanilla sdk instance if successfully initiated.
 * @returns {sdk instance} - optimizely vanilla sdk instance
 */
const initOptimizelyVanillaHelpersSDK = () => __awaiter(void 0, void 0, void 0, function* () {
    try {
        let optimizelyInstance;
        if (window.optimizelyVanillaHelpersSDKInstance) {
            optimizelyInstance = window.optimizelyVanillaHelpersSDKInstance;
        }
        else {
            optimizelyInstance = getOptimizelyVanillaSDKInstance();
            const result = yield optimizelyInstance.onReady();
            // 1. SAVING INSTANCE IN WINDOW
            if (result.success) {
                window.optimizelyVanillaHelpersSDKInstance = optimizelyInstance;
                window.optimizelyVanillaHelpersSDKInstance.notificationCenter.addNotificationListener(enums.NOTIFICATION_TYPES.DECISION, optimizelyVanillaOnDecision);
            }
        }
        return optimizelyInstance;
    }
    catch (e) {
        consoleEvents.error('Error with initializing Optimizely FS sdk ', e);
        return e;
    }
});
export default initOptimizelyVanillaHelpersSDK;
//# sourceMappingURL=initOptimizelyVanillaHelpersSDK.js.map